import React from 'react';
import { useFullPageStore, FULLPAGE_SECTIONS } from '../../stores/useFullPageStore';

/**
 * 右侧常驻标签式导航
 * 每项 = 序号 + 圆点 + 标签文字（永久可见, 方便点击跳转）
 * 当前项: 橙色 + 加粗 + 大字号
 */
export const SideDots: React.FC = () => {
  const index = useFullPageStore((s) => s.index);
  const setIndex = useFullPageStore((s) => s.setIndex);

  return (
    <nav className="fp-dots" aria-label="页面导航">
      <ul>
        {FULLPAGE_SECTIONS.map((s, i) => (
          <li key={s.id}>
            <button
              type="button"
              className={`fp-dot ${index === i ? 'fp-dot-active' : ''}`}
              onClick={() => setIndex(i, 'dot')}
              aria-label={s.label}
              data-index={i}
            >
              <span className="fp-dot-num">{String(i + 1).padStart(2, '0')}</span>
              <span className="fp-dot-core" />
              <span className="fp-dot-label">
                {s.icon && <i className={`fa-solid ${s.icon}`} />}
                <span>{s.label}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SideDots;
